import e from"color";const t=t=>{if(!t)return!1;try{e(t)}catch{return!1}return!0};export{t as isValidColor};
//# sourceMappingURL=is-valid-color.js.map